import { Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import Header from "./components/Header";
import HeaderBanner from "./components/HeaderBanner";
import About from "./components/About";
import Services from "./components/Services";
import Portfolio from "./components/Portfolio";
import Blog from "./components/Blog";
import Footer from "./components/Footer";
import Agenda from "./pages/Agenda";
import Hotel from "./pages/Hotel";
import Sponsor from "./pages/Sponsor";
import Login from "./Login";
import Signup from "./SignUp";
import Dashboard from "pages/Dashboard";
import ProtectedRoute from "./components/ProtectedRoute";

function App() {
  const location = useLocation();

  const noLayoutRoutes = ["/v1/login", "/v1/signup", "/v1/dashboard"];

  // Check if current route is login or signup
  const hideLayout = noLayoutRoutes.includes(location.pathname);

  return (
    <div className="App">
      {!hideLayout && <Header />}

      <Routes>
        <Route
          path="/"
          element={
            <>
              <HeaderBanner />
              <About />
              <Portfolio />
              <Services />
            </>
          }
        />
        <Route path="/agenda" element={<Agenda />} />
        <Route path="/hotel" element={<Hotel />} />
        <Route path="/sponsor" element={<Sponsor />} />
        <Route path="/v1/login" element={<Login />} />
        <Route path="/v1/signup" element={<Signup />} />
        <Route
          path="/v1/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
      </Routes>

      {!hideLayout && <Footer />}
    </div>
  );
}

export default App;
